import { render, staticRenderFns } from "./FsaRegistry.vue?vue&type=template&id=68d0a8ac&scoped=true"
import script from "./FsaRegistry.vue?vue&type=script&lang=ts&setup=true"
export * from "./FsaRegistry.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FsaRegistry.vue?vue&type=style&index=0&id=68d0a8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0a8ac",
  null
  
)

export default component.exports